import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/site";
import { Reveal, SectionMark } from "./Reveal";

export const ServicesSummary = () => (
    <section
        data-testid="services-summary"
        className="border-t border-white/[0.07] px-5 py-24 md:px-10 md:py-32"
    >
        <div className="mx-auto max-w-[1400px]">
            <div className="flex items-end justify-between">
                <Reveal>
                    <SectionMark>( Usluge )</SectionMark>
                </Reveal>
                <Reveal delay={0.1}>
                    <Link
                        to="/usluge"
                        data-testid="services-summary-all"
                        className="hidden items-center gap-2 border-b border-bone/25 pb-1 text-[11px] font-medium uppercase tracking-[0.26em] text-bone/80 transition-colors hover:border-bronze hover:text-bronze md:inline-flex"
                    >
                        Sve usluge <ArrowUpRight size={14} strokeWidth={1.5} />
                    </Link>
                </Reveal>
            </div>

            <div className="mt-10">
                {SERVICES.map((s, i) => (
                    <Reveal key={s.num} delay={i * 0.05}>
                        <Link
                            to="/usluge"
                            data-testid={`services-summary-${s.num}`}
                            className="group grid grid-cols-[48px_1fr_24px] items-baseline gap-4 border-t border-white/[0.07] py-6 transition-[padding] duration-500 hover:pl-3 md:grid-cols-[90px_1fr_1fr_32px] md:py-8"
                        >
                            <span className="font-display text-xl font-light text-bronze/70 md:text-2xl">
                                {s.num}
                            </span>
                            <h3 className="font-display text-xl font-light tracking-wide text-bone transition-colors duration-300 group-hover:text-bronze md:text-3xl">
                                {s.title}
                            </h3>
                            <p className="hidden max-w-sm text-sm leading-relaxed text-silver md:block">
                                {s.desc}
                            </p>
                            <ArrowUpRight
                                size={20}
                                strokeWidth={1.5}
                                className="justify-self-end text-silver transition-colors duration-300 group-hover:text-bronze"
                            />
                        </Link>
                    </Reveal>
                ))}
                <div className="border-t border-white/[0.07]" />
            </div>
        </div>
    </section>
);
